import * as React from 'react'
const SponsorsIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <path d="M16 28a.61.61 0 01-.19 0h-.06C6.58 23.16 7 16.26 7 16v-3.65H3.5A.51.51 0 013 12L2 7.52a.53.53 0 01.28-.59l6-2.88A.54.54 0 018.5 4h4a.46.46 0 01.33.13L16 7l3.18-2.84A.45.45 0 0119.5 4h4.21l6 2.88a.52.52 0 01.28.59L29 12a.5.5 0 01-.49.4H25V16c0 .25.42 7.15-8.74 11.92A.5.5 0 0116 28zM3.9 11.31h3.6a.51.51 0 01.5.52V16c0 .3-.33 6.45 8 10.88 8.37-4.45 8-10.78 8-10.88v-4.17a.51.51 0 01.5-.52h3.6l.82-3.61L23.39 5h-3.7l-3.36 3a.48.48 0 01-.65 0l-3.36-3H8.61L3.08 7.7z" className="-primary-color" fill="#a5aab8"/>
      <path d="M21.5 18h-11a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v5a.5.5 0 01-.5.5zM11 17h10v-4H11z" className="-secondary-color" fill="#d7dae0"/>
    </svg>
    
  )
}

export default SponsorsIcon